/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Label/view.blocks to change it.
import "DesignSystem/Fonts/Inter-400.css"
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import styles from './view.module.css'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function Label({
  children,
  viewPath = "/DesignSystem/VideoCapture/Content/CaptureFeed/Content/Label",
  height = 30,
  color = "rgb(50, 50, 50)",
  marginTop = 0,
  marginBottom = 0,
  text = ""
  
}) {
let dtTypographyFontsizeM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.fontSize.m'
        })
let dtTypographyFontweightRegular = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.fontWeight.regular'
        })
let dtTypographyLineheightM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.lineHeight.m'
        })
  return (<React.Fragment
>
<span
  data-testid="Label.Text"
  data-view-path={viewPath}
 style={{'--fs-1-5hnkT': typeof dtTypographyFontsizeM === 'number' ? `${dtTypographyFontsizeM}px` : dtTypographyFontsizeM,'--fw-2-5hnkT': dtTypographyFontweightRegular,'--lh-3-5hnkT': dtTypographyLineheightM,'--h-4-5hnkT': typeof height === 'number' ? `${height}px` : height,'--c-5-5hnkT': color,'--mt-6-5hnkT': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-7-5hnkT': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom}}
 className={`views-text ${styles.Text}`}
>
{text}
</span>
{children}
</React.Fragment>)
}